export interface IGroupActions {
  name: string
  type: string
  link: string
}
